var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-header-card',{staticClass:"animated fadeIn mt-3",attrs:{"icon":_vm.work_group.icon(),"header":`Work Group ${_vm.work_group.name} details`,"rows":_vm.rows}})
}
var staticRenderFns = []

export { render, staticRenderFns }